/**
 * CykelmakkerApi
 * CykelmakkerApi
 *
 * The version of the OpenAPI document: v3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ETypeOfDuration = 'ThisYear' | 'ThisMonth' | 'Today' | 'AllTime';

export const ETypeOfDuration = {
    ThisYear: 'ThisYear' as ETypeOfDuration,
    ThisMonth: 'ThisMonth' as ETypeOfDuration,
    Today: 'Today' as ETypeOfDuration,
    AllTime: 'AllTime' as ETypeOfDuration
};

